import React from 'react'
import "./WhyTrust.css"
import trustBg from '../assets/images/trustBg.png'
import trustfeather from '../assets/images/trustFeather.png'

export default function WhyTrust() {
  return (
    <div>
       <div className="why_trust_section">
          <div className="container-fluid">
             <div className="inner_why_trust_sec" style={{ backgroundImage: `url(${trustBg})` }}>
                <h1>Why Thousands of Families Trust CaresAtHome?</h1>
                <p>VERIFIED HEALTHCARE PROFESSIONALS, TRUSTED CARE</p>
                <div className="img_box_trust_sec">
                   <div className="img_outer_box_trust">
                     <img src={trustfeather} alt="trustfeather" />
                     <h4>100%</h4>
                     <p>NABL & ISO Certified Lab</p>
                   </div>

                   <div className="img_outer_box_trust">
                     <img src={trustfeather} alt="trustfeather" />
                     <h4>98% +</h4>
                     <p>Customer Satisfaction</p>
                   </div>

                   <div className="img_outer_box_trust">
                     <img src={trustfeather} alt="trustfeather" />
                     <h4>500+</h4>
                     <p>Healthcare Professionals</p>
                   </div>

                   <div className="img_outer_box_trust">
                     <img src={trustfeather} alt="trustfeather" />
                     <h4>24/7</h4>
                     <p>Care Support</p>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
  )
}
